// extracted by mini-css-extract-plugin
export default {"textarea":"AdminFhirDownloadAnonymous_textarea__zB5hG","progressDiv":"AdminFhirDownloadAnonymous_progressDiv__Xy-i5","groupId":"AdminFhirDownloadAnonymous_groupId__e707r"};